import { SellerEmployees as SellerEmployeesComponent } from 'components/sellers/SellerEmployees/SellerEmployees'
import { useParams } from 'react-router-dom'

export const SellerEmployees: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerEmployeesComponent sellerId={id as string} />
}
